import { setProperty } from './tools/fn';
export const header = (name, value) => setProperty(`Gotenberg-Remoteurl-${name}`)(value);
export const headers = (headers) => (_) => {
    for (const name in headers) {
        header(name, headers[name])(_);
    }
};
export const webhookHeader = (name, value) => setProperty(`Gotenberg-Webhookurl-${name}`)(value);
export const webhookHeaders = (headers) => (_) => {
    for (const name in headers) {
        webhookHeader(name, headers[name])(_);
    }
};
